import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useTranslationContext, default as useAutoTranslate } from '../../hooks/useAutoTranslate';
import fr from './langue/fr.json';
import en from './langue/en.json';

function Navbar({ onOpenCarte }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { langue, setLangue } = useTranslationContext();
  const t = useAutoTranslate({ fr, en });

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const otherLang = langue === 'fr' ? 'en' : 'fr';
  const langLabel = langue === 'fr' ? 'EN 🇬🇧' : 'FR 🇫🇷';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <div className="navbar__container">
          <button className="navbar__burger" onClick={() => setMenuOpen(!menuOpen)}>
            <span className={`burger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`burger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`burger-line ${menuOpen ? 'open' : ''}`}></span>
          </button>
          <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            <li><a href="#moi" onClick={() => setMenuOpen(false)}>{t('a_propos')}</a></li>
            <li><a href="#portfolio" onClick={() => setMenuOpen(false)}>{t('projets')}</a></li>
            <li><a href="#parcours" onClick={() => setMenuOpen(false)}>{t('parcours')}</a></li>
            <li><a href="#experience" onClick={() => setMenuOpen(false)}>{t('experiences')}</a></li>
            <li><a href="#comp" onClick={() => setMenuOpen(false)}>{t('cv')}</a></li>
            <li><a href="#contact" onClick={() => setMenuOpen(false)}>{t('contact')}</a></li>
            <li>
              {/* Bouton carte de visite */}
              <button
                className="navbar__carte"
                onClick={() => { onOpenCarte?.(); setMenuOpen(false); }}
                aria-label="Ouvrir la carte de visite"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="5" width="20" height="14" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                </svg>
              </button>
            </li>
            <li>
              <button className="navbar__lang" onClick={() => setLangue(otherLang)}>
                {langLabel}
              </button>
            </li>
          </ul>
        </div>
      </nav>

      <button
        className={`scroll-top-btn ${scrolled ? 'scroll-top-btn--visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Retour en haut"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="19" x2="12" y2="5" />
          <polyline points="5 12 12 5 19 12" />
        </svg>
      </button>
    </>
  );
}

export default Navbar;